import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getSupplierInvoicesCountByUtilityPerMonth, getSupplierInvoicesList} from "../../api";
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {Helmet} from "react-helmet";
import {DateFilterSupplierInvoices} from "../../components/table/filters/date-filter-supplierinvoices";
import SupplierTableHeader from "./supplier-table-header";
import SupplierTableRow from "./supplier-table-row";
import MonthlyUtilityChart from "../../components/charts/custom/supplier-monthly-unit-line-chart";
import {collateUtilityData} from "../../helpers/chart-dataset-helpers";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ReactGA from 'react-ga';
import queryString from 'query-string';
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary


function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}

class SupplierInvoices extends Component {
    static contextType = BreadcrumbContext;

//SupplierInvoices
    constructor(props)
    {
        super(props);
        this.stickyRef = React.createRef();
        this.checkSticky = this.checkSticky.bind(this);

        this.state = {
            dataProvider: new ApiDataProvider(getSupplierInvoicesList, [this.props.customerId]),
            //,this.constructQueryStringBasedOnURLParams()
            countData: {},
            nettCostData: {},
            initialCountData: {},
            initialNettCostData: {},
            filterValue: "", // This state will hold the filter value
            //supplierOverride: "", // New state for supplier override
            isSticky: false

        }
    }

    
    checkSticky = () => {
       
        if (this.stickyRef.current) {
            const stickyTop = this.stickyRef.current.getBoundingClientRect().top;
            const isSticky = stickyTop <= 200; // 70px is the top value in stickyGraphStyle
            if (isSticky !== this.state.isSticky) {
                this.setState({ isSticky, shouldHideSecondRow: isSticky });
            }
        }
    };

handleQueryParamsChange() {
    const queryParams = queryString.parse(this.props.location.search);
    const initialSupply = queryParams.utility;
    const initialDate = queryParams.date;
  
    // Assuming you have a method to update the component's state or fetch new data based on these parameters
    this.setState({
      supplyOverride: initialSupply,
      initialDate: initialDate,
    });
  
    this.fetchData(initialSupply); 
  
    // Any other actions that need to be performed when query params change
  }

  componentDidUpdate(prevProps) {
    // Check if the URL's query parameters have changed
    if (this.props.location.search !== prevProps.location.search) {
      this.handleQueryParamsChange();
    }

        if (prevProps.defaultUtility !== this.props.defaultUtility) {
            this.setState({ initialSetupDone: false });
        }
    
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkSticky);
 }

    componentDidMount() {

        console.log("Mounted")
        this.handleQueryParamsChange();

        const queryParams = queryString.parse(this.props.location.search);
        const initialSupply = queryParams.utility; // Assuming date is passed as "YYYY-MM-DD"
        const initialDate = queryParams.date; // Assuming date is passed as "YYYY-MM-DD"

        this.context.addBreadcrumb({ title: "Supplier Invoices" , path: '/supplier-invoices' + this.props.location.search});

        window.addEventListener('scroll', this.checkSticky);
        setTimeout(this.checkSticky, 100); // Delay to ensure the component is fully rendered
       

       // var status = initialSupply//"Gas"


        // this.filterableDataTableRef.onAdvancedFilterChange({
        //     name: "Utility",
        //     value: status
        // });

        // this.setState({
        //     supplyOverride: status,
        //     initialDate : initialDate
        // })


        //     this.fetchData(status); 

            ReactGA.pageview(window.location.pathname);
   
    }

    updateFilterValue = (newFilterValue) => {
      
        // Assuming you store the filter value in state like this:
        this.setState({ filterValue: newFilterValue });
      };

      
    // Method to update supplierOverride
    updateSupplierOverride = (newSupplierOverride) => {
        this.setState({ supplierOverride: newSupplierOverride }, () => {
            // Optionally, perform additional actions here
            //this.fetchData(newSupplierOverride);
            this.filterableDataTableRef.onAdvancedFilterChange({
                name: "Supplier",
                value: newSupplierOverride
            });
        });
    };

    // Inside SupplierInvoices component
    updateSupplyOverride = (newSupplyOverride) => {
      
        this.setState({ supplyOverride: newSupplyOverride }, () => {
        // You can perform additional actions here if needed, such as refreshing data
        this.fetchData(newSupplyOverride);
        });
    };


trimGraphDates = (toDate, fromDate) => {
  
    
    
    const trimmedCountData = this.trimGraphData(this.state.initialCountData, toDate, fromDate);
    const trimmedNettCostData = this.trimGraphData(this.state.initialNettCostData, toDate, fromDate);

    // Update the state with the trimmed data
    this.setState({
        countData: trimmedCountData,
        nettCostData: trimmedNettCostData
    });
};

trimGraphData = (data, toDate, fromDate) => {
    // Check if data is an array
    if (!Array.isArray(data)) {
        //console.error('Data is not an array:', data);
        return [{}];
    }

    // Convert toDate and fromDate to Date objects
    const toDateObj = new Date(toDate);
    const fromDateObj = new Date(fromDate);

    // Set the start and end of the months for comparison
    const fromStartOfMonth = new Date(fromDateObj.getFullYear(), fromDateObj.getMonth(), 1);
    const toEndOfMonth = new Date(toDateObj.getFullYear(), toDateObj.getMonth() + 1, 0);


    // Filter the data based on the date range
    const trimmedData = data.filter(entry => {
        const entryDate = new Date(entry.date);
        return entryDate >= fromStartOfMonth && entryDate <= toEndOfMonth;
    });


    return trimmedData;
};






    fetchData = (status) => {
        getSupplierInvoicesCountByUtilityPerMonth(this.props.customerId)
            .then((utilityData) => {
                this.setState({
                    
                    countData: collateUtilityData(utilityData, "count"),
                    nettCostData: collateUtilityData(utilityData, "nettCost") ,
                    initialCountData: collateUtilityData(utilityData, "count"),
                    initialNettCostData: collateUtilityData(utilityData, "nettCost") 
                
                
                }
                    
                    
                    , () => {
                        // This callback ensures that filters are applied after state is updated
                        if(status !== "") {
                            this.filterableDataTableRef.onAdvancedFilterChange({
                                name: "Utility",
                                value: status
                            });
                        }
                    })


                    
            });
    }

    

    render() {

        const stickyGraphStyle = {
            position: 'sticky',
            top: '50px',
            zIndex: 100,
            backgroundColor: 'white',
            padding: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: this.state.isSticky ? 'flex' : 'none' // LG Instructions: Initially hide this Grid.Row
        };
        
        return (
            <div className="main-container">
                <Helmet>
                    <title>Inenco Portal | Supplier Invoices</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Supplier Invoices</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row style={stickyGraphStyle}>
                        <Grid.Column>
                            {this.state.nettCostData.length > 0 && <MonthlyUtilityChart  size={"compress"} data={this.state.nettCostData} label={"£"} title={"Monthly Nett Cost"} defaultUtility={this.state.supplyOverride}/> }
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.countData.length > 0 && <MonthlyUtilityChart size={"compress"} data={this.state.countData} label={"Count"} title={"Monthly Utility Count"} defaultUtility={this.state.supplyOverride}/> }
                        </Grid.Column>
                    </Grid.Row>

                    {!this.state.isSticky && ( <>

                    <Grid.Row>
                        <Grid.Column>
                            {this.state.nettCostData.length > 0 && <MonthlyUtilityChart data={this.state.nettCostData} label={"£"} title={"Monthly Nett Cost"} defaultUtility={this.state.supplyOverride}/> }
                        </Grid.Column>
                        <Grid.Column>
                            {this.state.countData.length > 0 && <MonthlyUtilityChart data={this.state.countData} label={"Count"} title={"Monthly Utility Count"} defaultUtility={this.state.supplyOverride}/> }
                        </Grid.Column>
                    </Grid.Row>
                    </> )}
                    <Grid.Row>
                        <Grid.Column>
                            <div ref={this.stickyRef}  className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} 
                                name="supplier-invoices"
                                ref={(ref) => (this.filterableDataTableRef = ref)}  
                                canExport={true}
                                filterComponent={DateFilterSupplierInvoices} 
                                filterComponentProps={{
                                    initialDate: this.state.initialDate, // Make sure this is passed correctly
                                    filter: this.state.filterValue, // Pass the filter value to DateFilterSupplierInvoices
                                    filterValue: this.state.filterValue, // Ensure you are passing this
                                    updateSupplyOverride: this.updateSupplyOverride, // Pass the callback here
                                    updateSupplierOverride: this.updateSupplierOverride, // New callback 
                                    trimGraphDates : this.trimGraphDates
                                }}
                                                    supplierOverride={this.state.supplierOverride}

                                                     supplyOverride={this.state.supplyOverride}
                                                     initialDate= {this.state.initialDate} // Ensure this is correctly derived and passed down                                                    

                                                     contextData={{
                                                        customerId: this.props.customerId,
                                                        updateSupplyOverride: this.updateSupplyOverride, // Pass the callback here
                                                        updateSupplierOverride: this.updateSupplierOverride, // New callback 
                                                        updateFilterValue: this.updateFilterValue, // Pass the method down
                                                    }}
                                                     headerComponent={SupplierTableHeader} rowComponent={SupplierTableRow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default wrap(SupplierInvoices);